import { TranslateFunc } from 'components/translate/src/translate-func';
import { ShippingCollection, StockStatus } from 'src/types';

export enum ShippingType {
  CHEAPEST = 'cheapest',
  FASTEST = 'fastest',
}

type DeliveryDays = {
  min: number;
  max: number;
} | null;

const getUpToDaysText = (t: TranslateFunc, nbr: number) => {
  return t('product', `delivery-time.up-to`, { n: nbr });
};

export const isStockStatusSupported = (stockStatus?: StockStatus | null) =>
  stockStatus === 'in_stock';

export const getDeliveryDays = (
  type: ShippingType,
  shippingCollection?: ShippingCollection | null
): DeliveryDays => {
  const selectedShipping = shippingCollection?.[type];
  if (!shippingCollection || !selectedShipping) {
    return null;
  }

  if (
    !selectedShipping.deliveryDays ||
    selectedShipping.deliveryDays.min < 0 ||
    selectedShipping.deliveryDays.max < 0
  ) {
    return null;
  }
  return {
    min: selectedShipping.deliveryDays.min,
    max: selectedShipping.deliveryDays.max,
  };
};

export const getDeliveryDaysText = (
  t: TranslateFunc,
  type: ShippingType,
  shippingCollection?: ShippingCollection | null
) => {
  const day = t('product', `delivery-time.days-label`);
  const days = t('product', `delivery-time.days-label-plural`);
  const deliveryDays = getDeliveryDays(type, shippingCollection);

  if (!deliveryDays) {
    return null;
  }
  if (deliveryDays.min === 1 && deliveryDays.max === 1) {
    return `${deliveryDays.max} ${day}`;
  }
  if (deliveryDays.min === 0 && deliveryDays.max === 0) {
    return `${deliveryDays.max} ${days}`;
  }
  if (deliveryDays.min === 0) {
    return getUpToDaysText(t, deliveryDays.max);
  }
  if (deliveryDays.min === deliveryDays.max) {
    return `${deliveryDays.max} ${days}`;
  }
  return `${deliveryDays.min}-${deliveryDays.max} ${days}`;
};

export const getStandardizedDeliveryText = (
  t: TranslateFunc,
  stockStatus?: StockStatus | null
) => {
  switch (stockStatus) {
    case 'in_stock':
      return getUpToDaysText(t, 6);
    case 'incoming':
      return t('product', `delivery-time.incoming`);
    case 'in_stock_preorder':
      return t('product', `stock-status.pre_order`);
    case 'not_in_stock':
      return t('product', `delivery-time.unavailable`);
    case 'unknown':
    default:
      return t('product', `delivery-time.unknown`);
  }
};

export const getDeliveryDaysTextNew = (
  t: TranslateFunc,
  type: ShippingType,
  shippingCollection?: ShippingCollection | null
) => {
  const day = t('product', `delivery-time.days-label`);
  const days = t('product', `delivery-time.days-label-plural`);
  const deliveryDays = getDeliveryDays(type, shippingCollection);

  if (!deliveryDays) {
    return null;
  }
  if (deliveryDays.min === 1 && deliveryDays.max === 1) {
    return `${deliveryDays.max} ${day}`;
  }
  if (deliveryDays.min === 0 && deliveryDays.max === 0) {
    return `${deliveryDays.max} ${days}`;
  }
  if (deliveryDays.min === deliveryDays.max) {
    return `${deliveryDays.max} ${days}`;
  }
  return `${deliveryDays.min}-${deliveryDays.max} ${days}`;
};

export const getStandardizedDeliveryTextNew = (
  t: TranslateFunc,
  stockStatus?: StockStatus | null
) => {
  switch (stockStatus) {
    case 'in_stock':
      return `0-6 ${t('product', `delivery-time.days-label-plural`)}`;
    case 'incoming':
      return t('product', `delivery-time.incoming`);
    case 'in_stock_preorder':
      return t('product', `stock-status.pre_order`);
    case 'not_in_stock':
      return t('product', `delivery-time.unavailable`);
    case 'unknown':
    default:
      return t('product', `delivery-time.unknown`);
  }
};
